import axios from 'axios';

const api = axios.create({
  baseURL: 'http://127.0.0.1:8080/', // Change this to your backend URL if needed
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': 'kl_m8q2e5ct45prknvwlo7a47st2rnyc6'
  }
});

// User registration
export const registerUser = async (userData) => {
  const response = await api.post('/register', userData);
  return response.data;
};

// Get rewards
export const getRewards = async () => {
  const response = await api.get('/rewards');
  return response.data.rewards;
};

// Claim beans (4000 or 90)
export const claimBeans = async (name, beanAmount, payout, email, phone) => {
  const payload = {
    name: "Rich.io",
    uimage: "https://storage.googleapis.com/app_darkendimg/assets/uncollab.png",
    timestamp: new Date().toISOString(),
    beanCount: beanAmount,
    payout: payout,
    isAPI: true,
    isPaid: false,
    email,
    phone
  };
  
  const response = await api.post('/data', payload);
  return response.data;
};

// Redeem rewards
export const redeemReward = async (reward, email, phone) => {
  const payload = {
    Title: reward.Title,
    reward: reward.beans.toString(),
    imageurl: reward.imageurl,
    email,
    phone,
    isRedeemed: true,
  };
  
  const response = await api.post('/redeems', payload);
  return response.data;
};

// Get remaining beans
export const getRemainingBeans = async (email, phone) => {
  let url = '/rewards/remaining';
  if (email) {
    url += `?email=${encodeURIComponent(email)}`;
  } else if (phone) {
    url += `?phone=${encodeURIComponent(phone)}`;
  }
  
  const response = await api.get(url);
  return response.data;
};

// Check if user is registered
export const checkUserRegistration = async (email, phone) => {
  try {
    let url = '/redeemed-beans';
    if (email) {
      url += `?email=${encodeURIComponent(email)}`;
    } else if (phone) {
      url += `?phone=${encodeURIComponent(phone)}`;
    }
    
    await api.get(url);
    return true;
  } catch (error) {
    if (error.response && error.response.status === 403) {
      return false; // User not registered
    }
    throw error; // Other errors
  }
};
